/**
 * Drink / wine category titles — used when Speisekarte shares a Menu Book with
 * Weinkarte so food chips do not also list the drink section below.
 */
const DRINK_LIKE_CATEGORY_RE =
  /(?:^|\b)(getränke|getraenke|drinks?|beverages?|wein(?:karte)?|wines?|cocktails?)(?:\b|$)/i;

export function isDrinkLikeMenuCategoryTitle(
  title: string | Record<string, string> | null | undefined,
): boolean {
  if (!title) {
    return false;
  }
  const blob = typeof title === 'string' ? title : Object.values(title).join(' ');
  return DRINK_LIKE_CATEGORY_RE.test(blob);
}
